import { useQuery } from '@tanstack/react-query';
import { instrumentTypesQueryKey } from './keys';
import type { FinancialInstrumentCatalogs, InstrumentTypeOption } from '../types';

const STALE_TIME = 5 * 60 * 1000; // los catálogos cambian poco (§7.4)

export interface UseInstrumentTypesParams {
  catalogs?: Pick<FinancialInstrumentCatalogs, 'loadInstrumentTypes'>;
  enabled?: boolean;
}

/**
 * Carga los tipos de instrumento activos para el `Select` del campo tipo
 * (105-17.02). GAP-2: mientras el catálogo no exista en Core, se omite `catalogs`
 * y la query queda deshabilitada (el campo cae a chip read-only con el default).
 */
export function useInstrumentTypes({ catalogs, enabled = true }: UseInstrumentTypesParams) {
  return useQuery<InstrumentTypeOption[]>({
    queryKey: instrumentTypesQueryKey(),
    enabled: enabled && Boolean(catalogs?.loadInstrumentTypes),
    staleTime: STALE_TIME,
    queryFn: () => catalogs!.loadInstrumentTypes(),
  });
}
